// @flow
import type {SagaIterator} from 'redux-saga';

import {LOCATION_CHANGED} from 'constants/actions';

import {put, takeLatest} from 'redux-saga/effects';
import {toggleSticky} from 'actions/product/sticky';

/**
 * Resets sticky to initial state
 */
export function* resetSticky(): SagaIterator {
    yield put(toggleSticky(false));
}

/**
 * Begin of discountPrice saga
 */
export default function* stickySaga(): SagaIterator {
    yield takeLatest(LOCATION_CHANGED, resetSticky);
}
